<template>
  <section id="help-home-contact-us" class="pt-12">
    <div class="bg-light-green pt-12">
      <header class="text-center">
        <h2
          class="
            uppercase
            font-druk
            text-display-10
            tracking-02-em
            leading-10
            md:text-display-14
            md:leading-14
          "
        >
          {{ $messages("help.help_contact.title") }}
        </h2>
      </header>

      <div
        class="
          mx-auto
          w-44
          md:w-full
          md:container
          md:flex
          md:justify-between
          lg:justify-center
          mt-8
        "
      >
        <article class="mb-8 mb:mb-0">
          <MajorityUiMajorityIcon icon="calling" class="flex text-smaller mb-2" />
          <h3
            class="
              uppercase
              font-gt-america-extended
              text-tiny
              leading-3
              text-middle
              md:text-smallest
              md:-tracking-04-em
              md:leading-4
              mb-2
            "
          >
            {{ $messages("help.help_contact.call_us") }}
          </h3>
          <a
            class="
              flex
              font-medium
              text-smaller
              leading-4
              -tracking-01-em
              md:text-base
              md:leading-5
              md:tracking-normal
              link-unstyled
              hover:underline
            "
            :href="`tel:${getPhoneNumber}`"
            data-test-id="link-the-help-contact-phone-number"
          >
            {{ getPhoneNumber }}
          </a>
        </article>

        <article class="mb-8 mb:mb-0 md:mx-17 lg:mx-22">
          <MajorityUiMajorityIcon icon="speech-bubble" class="flex text-smaller mb-2" />
          <h3
            class="
              uppercase
              font-gt-america-extended
              text-tiny
              leading-3
              text-middle
              md:text-smallest
              md:-tracking-04-em
              md:leading-4
              mb-2
            "
          >
            {{ $messages("help.help_contact.ask_us") }}
          </h3>
          <a
            class="
              flex
              font-medium
              text-smaller
              leading-4
              -tracking-01-em
              md:text-base
              md:leading-5
              md:tracking-normal
              link-unstyled
              hover:underline
            "
            :href="`mailto:${getEmail}`"
            data-test-id="link-the-help-contact-email"
          >
            {{ getEmail }}
          </a>
        </article>

        <article>
          <MajorityUiMajorityIcon icon="map-pin" class="flex text-smaller mb-2" />
          <h3
            class="
              uppercase
              font-gt-america-extended
              text-tiny
              leading-3
              text-middle
              md:text-smallest
              md:-tracking-04-em
              md:leading-4
              mb-2
            "
          >
            {{ $messages("help.help_contact.meetup_place") }}
          </h3>
          <a
            :href="`https://www.google.com/maps/place/${addressUrl}}`"
            target="_blank"
            class="
              flex
              font-medium
              text-smaller
              leading-4
              -tracking-01-em
              md:text-base
              md:leading-5
              md:tracking-normal
              link-unstyled
              hover:underline
            "
            v-html="$messages('help.meetup.address')"
          />
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'pinia'
import { applicationContentStore } from '@/store/application/content'
export default {
  name: 'TheHelpContact',
  computed: {
    ...mapState(applicationContentStore, {
      getEmail: 'getHelpEmail',
      getPhoneNumber: 'getContactNumber'
    }),
    addressUrl () {
      return this.$messages('help.meetup.address')
        .replace('<br>', '')
        .replace('<br/>', '')
        .replace('<br />', '')
        .replace(/\W+/g, '')
        .split(/ |\B(?=[A-Z])/)
        .join('+')
    }
  }
}
</script>
